import matching from './matching'
import applications from './applications'

export default [
    ...applications,
    ...matching,
]